import UsageReports from './usage-reports.vue'

import {API2_ANALYTICS} from 'consts/api2'
const __default__ = {
  data() {
    const data = {
      active: 'usage_reports',
      tabs: [
        {value: 'usage_reports', title: 'Usage Reports'},
        {value: 'stats', title: 'Stats'}
      ]
    }
    return data
  },
  computed: {
    stats_api(){
      return `${API2_ANALYTICS}/stats`
    }
  },
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'analytics',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { get API2_ANALYTICS() { return API2_ANALYTICS }, UsageReports }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})